import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useState } from 'react';
//import { SCFormString } from '..';
import { FormString } from 'eone-ui/forms/form-string';
import { SecureButton } from '../secure_button';
import { SCView } from '../view';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';
import { handleFieldUp } from './helper';
//import './styles.css';

interface SCFormFieldStringProps extends SCFormFieldProps {
  AutoFocus?: boolean;
  Icon?: IconProp;
  Password?: boolean;
  validChars?: string[];
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  onDoubleClick?: () => void;
  formatter?: (value: string) => string;
  Buttons?: any[];
  SuffixButtons?: any[];
  ShowDropdownButton?: boolean;
  DropdownLabel?: string;
  DropdownIcon?: any;
  DropdownOptions?: any[];
  Placeholder?: string;
  /** Skip internal onChange call to prevent validation. Use with setValue shouldValidate: false */
  skipInternalOnChange?: boolean;
}

const SCFormFieldString = ({
  label,
  name,
  required,
  disabled,
  rules,
  visible,
  onChange,
  onBlur,
  formatter,
  secure,
  secureReadonly,
  defaultValue,
  //skipInternalOnChange,
  //validChars,
  ...rest
}: SCFormFieldStringProps) => {
  const [isClear, setIsClear] = useState(!secureReadonly);
  const [isSecure, setIsSecure] = useState(secure);

  return (
    <SCFormField
      visible={visible}
      label={label}
      name={name}
      disabled={disabled}
      required={required || !!rules?.required}
      rules={rules}
      defaultValue={defaultValue}
    >
      {({ field, extraProps }) => {
        const { Value, ...handleField } = handleFieldUp(field, { disabledRef: true });
        return (
          <SCView flex flexRow wFull justifyEnd itemsEnd>
            <SCView flex flex1>
              <SCView wFull>
                <FormString
                  ReadOnly={field.disabled}
                  {...handleField}
                  OnChange={(value) => {
                    if (secure && secureReadonly && !isClear) {
                      formatter = () => '';
                      setIsClear(true);
                    }
                    const newValue = formatter ? formatter(value) : value;
                    onChange?.(newValue);
                    handleField.OnChange(newValue);
                  }}
                  OnBlur={(value) => {
                    if (secure && secureReadonly && !isClear) {
                      formatter = () => '';
                      setIsClear(true);
                    }
                    const newValue = formatter ? formatter(value) : value;
                    onBlur?.(newValue);
                    handleField.OnBlur(newValue);
                  }}
                  Label={label}
                  Value={isSecure && !isClear ? '******' : Value}
                  Required={required || !!rules?.required}
                  ShowRequiredIndicator={required}
                  Password={isSecure}
                  {...rest}
                  {...extraProps}
                />

                {/*<SCFormString*/}
                {/*  ReadOnly={field.disabled}*/}
                {/*  {...handleField}*/}
                {/*  OnChange={(value) => {*/}
                {/*    if (secure && secureReadonly && !isClear) {*/}
                {/*      formatter = () => '';*/}
                {/*      setIsClear(true);*/}
                {/*    }*/}
                {/*    const newValue = formatter ? formatter(value) : value;*/}
                {/*    onChange?.(newValue);*/}
                {/*    // Skip internal onChange if skipInternalOnChange is true*/}
                {/*    // This allows parent to use setValue with shouldValidate: false*/}
                {/*    if (!skipInternalOnChange) {*/}
                {/*      handleField.OnChange(newValue);*/}
                {/*    }*/}
                {/*  }}*/}
                {/*  OnBlur={(value) => {*/}
                {/*    if (secure && secureReadonly && !isClear) {*/}
                {/*      formatter = () => '';*/}
                {/*      setIsClear(true);*/}
                {/*    }*/}
                {/*    const newValue = formatter ? formatter(value) : value;*/}
                {/*    onBlur?.(newValue);*/}
                {/*    handleField.OnBlur(newValue);*/}
                {/*  }}*/}
                {/*  OnDoubleClick={rest.onDoubleClick}*/}
                {/*  Label={label}*/}
                {/*  Value={isSecure && !isClear ? '******' : Value}*/}
                {/*  Required={required || !!rules?.required}*/}
                {/*  ShowRequiredIndicator={required}*/}
                {/*  ValidChars={validChars}*/}
                {/*  Password={isSecure}*/}
                {/*  {...rest}*/}
                {/*  {...extraProps}*/}
                {/*/>*/}
              </SCView>
            </SCView>
            <SCView style={{ paddingBottom: 12 }}>
              {secure && isClear && <SecureButton defaultSecure onChange={setIsSecure} />}
            </SCView>
          </SCView>
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldString };
export type { SCFormFieldStringProps };
